var components
var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  var l0 =
    _vm.isLieBiao == true
      ? _vm.__map(_vm.listData, function (item, index) {
          var $orig = _vm.__get_orig(item)
          var m0 =
            _vm.index_open_city == 0 ||
            (_vm.index_open_city == 1 &&
              _vm.isInArray2(_vm.city_supplier_ids, item.shop_supplier_id))
          var g0 = m0 ? _vm.listData.length : null
          return {
            $orig: $orig,
            m0: m0,
            g0: g0,
          }
        })
      : null
  var l1 =
    _vm.isLieBiao == false
      ? _vm.__map(_vm.listData, function (item, index) {
          var $orig = _vm.__get_orig(item)
          var m1 =
            _vm.index_open_city == 0 ||
            (_vm.index_open_city == 1 &&
              _vm.isInArray2(_vm.city_supplier_ids, item.shop_supplier_id))
          return {
            $orig: $orig,
            m1: m1,
          }
        })
      : null
  var g1 = _vm.listData.length == 0 && !_vm.loading
  _vm.$mp.data = Object.assign(
    {},
    {
      $root: {
        l0: l0,
        l1: l1,
        g1: g1,
      },
    }
  )
}
var recyclableRender = false
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns, recyclableRender, components }